var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11361 0.847926L1.60679 8.36047C1.4295 8.5379 1.31131 8.75479 1.2324 8.99151L0.0305247 13.1126C-0.0482272 13.3491 0.0305245 13.6055 0.207819 13.8028C0.345807 13.9409 0.523098 14 0.700393 14C0.759491 14 0.83838 14 0.897478 13.9803L5.01539 12.7775C5.25179 12.6987 5.46852 12.5803 5.64596 12.4029L13.1725 4.8706C13.7045 4.33818 14 3.60865 14 2.83965C14 2.07065 13.7045 1.3608 13.1725 0.808702C12.0493 -0.275962 10.2366 -0.276075 9.11361 0.847926ZM5.11392 10.983L3.02544 8.89289L8.73929 3.17468L10.8279 5.26461L5.11392 10.983ZM2.33591 10.135L3.87274 11.673L1.70534 12.3041L2.33591 10.135ZM12.1874 3.90414L11.813 4.27867L9.72451 2.18861L10.0989 1.81393C10.3944 1.51822 10.7688 1.38014 11.1432 1.38014C11.5175 1.38014 11.8919 1.51823 12.1874 1.81393C12.7587 2.4055 12.7587 3.33225 12.1874 3.90414Z",
    fill: "#092C4C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.036676f54224b55948f53f000f20ecd1.svg";
export { ForwardRef as ReactComponent };